import { Icon } from 'anf-core-react';
import PropTypes from 'prop-types';
import React from 'react';
import style from './PillButton.module.scss';

function PillButton({ name, clickHandler = () => {}, iconOptions = {} }) {
  const { name: iconName, position = 'right', labelText } = iconOptions || {};

  return (
    <button
      className={style.pillButton}
      onClick={clickHandler}
      type="button"
      value={`${name}`}
    >
      {iconName && position === 'left' ? <Icon icon={iconName} labelText={labelText} size="xs" /> : null}
      <span>{name}</span>
      {iconName && position === 'right' ? <Icon icon={iconName} labelText={labelText} size="xs" /> : null}
    </button>
  );
}

export default PillButton;

PillButton.propTypes = {
  name: PropTypes.string.isRequired,
  clickHandler: PropTypes.func,
  iconOptions: PropTypes.shape({
    name: PropTypes.string,
    position: PropTypes.oneOf(['left', 'right']),
    labelText: PropTypes.string,
  }),
};
